export const BetaFeatures = {
  FOODMAESTRO_ENABLED: 'FOODMAESTRO_ENABLED',
};

export const SUITABILITY_EMPTY = {
  isSuitable: -1,
  reason: '',
  unsuitableConditions: [],
  containIngredients: [],
  mayContainIngredients: [],
};
